import type { SectionOption } from "./sectionType"

export function mapToSectionOptions(values: string[] | undefined | null): SectionOption[] {
  if (!values) return []

  return values
    .filter(Boolean)
    .map(v => ({
      value: v,
      label: v.charAt(0).toUpperCase() + v.slice(1),
    }))
}